import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { MessageService } from 'primeng/api';
import { I18NextService } from 'angular-i18next';
import { AutorunComponent } from '@myshared/autorun.component';
import { CountryService } from '../../../country/country.service';
import { Model } from '../../../app.model';
import { CompanyService } from '../../company.service';
import { Company, SignupCompany } from '../../company.model';
import { CookieHelper } from "@myshared/cookieHelper";
import {firstValueFrom} from "rxjs";
import {Country} from "../../../country/country.model";
import {FormEmitter} from "../../../forms/form.component";

@Component({
    selector: 'app-company-create',
    templateUrl: './company-create.component.html',
    standalone: false
})
export class CompanyCreateComponent extends AutorunComponent implements OnInit {
  @Output() create = new EventEmitter<void>();

  company: Company;
  countries: Country[];

  constructor(private m: Model,
    private countryService: CountryService,
    private companyService: CompanyService,
    private messageService: MessageService,
    private i18next: I18NextService) {
    super();
  }

  async ngOnInit() {
    const code = await firstValueFrom(this.countryService.traceCountry()) as string;
    const allowedCountryCodes = ['DE', 'AT', 'CH'];
    this.autorun(() => {
      this.countries = (this.m.country.countries ?? [])
        .filter(country => allowedCountryCodes.includes(country.code.toUpperCase()));
      if (this.countries.length > 0) {
        const company = this.m.company.company;
        company.country = this.m.country.findCountryByCde(code) ?? this.countries[0];
        this.company = company;
      }
    });

    this.countryService.refresh();
    this.companyService.refresh();
  }

  onCreate(form: FormEmitter<Company>) {
    const company = form.data;
    const c = company as SignupCompany;
    c.email = this.m.account.currentUser.email;
    c.vat = '';
    c.campaign_id = CookieHelper.get('p_cid') ?? '';
    this.companyService.update(c).subscribe(r => {
      if (r) {
        this.messageService.add({
          severity: 'success',
          summary: this.i18next.t('company_update_success_summary') as string,
          detail: this.i18next.t('company_update_success_detail') as string
        });
        this.create.emit();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: this.i18next.t('company_update_error_summary') as string,
          detail: this.i18next.t('company_update_error_detail') as string
        });
      }
    });
  }
}
